import callApi from '../../util/apiCaller';

import { addError } from '../Error/ErrorActions';

export const SET_TAXES = 'SET_TAXES';
export const REMOVE_TAX = 'REMOVE_TAX';


export function getTaxesRequest(refreshCache = false) {
    return dispatch => {
        return callApi(`taxes${refreshCache ? '?refreshCache=1' : ''}`).then(res => {
            res.taxes && dispatch(setTaxes(res.taxes));
            return res.taxes;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function editTaxRequest(tax) {
    return dispatch => {
        return callApi('tax/edit', 'post', { tax }).then(res => {
            dispatch(getTaxesRequest(true));
            return res.tax;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function removeTaxRequest(taxId) {
    return dispatch => {
        return callApi('tax/remove', 'delete', { tax: { _id: taxId } }).then(res => {
            dispatch(removeTax(taxId));
            return res.ok;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

// Getters
export function getTaxes(store) {
    return store.taxes.data;
}

export function getTaxByCountry(store, country = '*') {
    return store.taxes.data.find(tax => isTaxAplicable(tax, country));
}

export function isTaxAplicable(tax, country = '*') {
    return tax.countries.includes(country);
}

export function setTaxes(taxes) {
    return {
        type: SET_TAXES,
        taxes,
    };
}

export function removeTax(id) {
    return {
        type: REMOVE_TAX,
        id,
    };
}
